<div class="material-theme-login">
  <module-container [customStyle]="{ 'margin-top': 0, padding: '0.8vw' }">
    <div class="controller-container">
      <div *ngIf="currentInputDocument == undefined">
        <button mat-raised-button color="accent" (click)="getNextFile()" [disabled]="isloading">
          Start Job
        </button>
      </div>
      <div *ngIf="currentInputDocument != undefined">
        <button mat-raised-button color="warn" (click)="releaseFile()" [disabled]="isloading">
          Stop Job
        </button>
      </div>
      <div class="job-title-container">
        <span>Duplicate Job</span>
      </div>
    </div>
  </module-container>
</div>

<div *ngIf="currentInputDocument != undefined" class="job-container material-theme-login">
  <div [style.width]="pdfWidth == null ? '50%' : pdfWidth + 'px'" class="file-container">
    <module-container type="full-height" title="Original Document">
      <pdf-viewer
        [uuid]="currentInputDocument.originalUuid"
        (pdfWidth)="changePdfWidth($event)"
      ></pdf-viewer>
    </module-container>
  </div>
  <div [style.width]="pdfWidth == null ? '50%' : pdfWidth + 'px'" class="file-container">
    <module-container type="full-height" title="Duplicate Document">
      <pdf-viewer
        [uuid]="currentInputDocument.uuid"
        (pdfWidth)="changePdfWidth($event)"
      ></pdf-viewer>
    </module-container>
  </div>
  <div class="form-container">
    <module-container>
      <form class="discard-form">
        Document Review
        <mat-divider></mat-divider>
        <button
          mat-raised-button
          color="accent"
          (click)="onDuplicateClick()"
          [disabled]="isloading"
        >
          Confirm Duplicate
        </button>
      </form>
    </module-container>

    <div class="floating-button-container">
      <module-container>
        <div class="button-container">
          <button mat-stroked-button (click)="onRestoreClick()" [disabled]="isloading">
            Restore
          </button>
          <button mat-stroked-button (click)="onAllocateClick()" [disabled]="isloading">
            Allocate
          </button>
        </div>
      </module-container>
    </div>
  </div>
</div>
